import React from "react";

export const useFormFieldIds = (id?: string) => {
  const generatedId = React.useId();
  const fieldId = id || generatedId;

  return {
    fieldId,
    labelId: `label-${fieldId}`,
    errorId: `error-${fieldId}`,
  };
};
